export class ConfigService {
  navigationType = 'history';

  domain = null;

  home = 'core/dash/home';

  spaSiteDomain = null;

  appPrefix = '/rcore';

  useSampleData = true;

  logo = '/core/headerlogo.sumttheme';

  secondaryLogo = 'core/secondaryheaderlogo.sumttheme';

  favicon = 'core/favicon.sumttheme';

  api = {
    userMocks: true,
    url: process.env.API_URL || '/api'
  };

  constructor() {
    const link = document.createElement('a');
    link.href = document.location.href;
    this.spaSiteDomain = `${link.protocol}//${link.host}`;

    const suiteDomain = process.env.REACT_APP_SUITE_DOMAIN;

    if (!suiteDomain || suiteDomain === 'null') {
      this.domain = `${link.protocol}//${link.host}/`;
    } else {
      this.domain = process.env.REACT_APP_SUITE_DOMAIN;
    }
  }

  static get instance() {
    return config;
  }
}

const config = new ConfigService();

export default config;
